import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft, Bell, Mail, Moon, Briefcase,
  Eye, EyeOff, Lock, Globe, Trash2, LogOut,
  ChevronRight, CheckCircle, X,
} from 'lucide-react';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../../../../assets/css/screens/serviceprovider/dashboard/settings/Settings.css';
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import AppContext from '../../../../context/AppContext';

/* ── Toggle ── */
const Toggle = ({ checked, onChange }) => (
  <button
    className={`settings-toggle ${checked ? 'settings-toggle--on' : ''}`}
    onClick={() => onChange(!checked)}
    role="switch"
    aria-checked={checked}
  >
    <span className="settings-toggle-thumb" />
  </button>
);

/* ── Password Input ── */
const PasswordInput = ({ value, onChange, placeholder }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="sp-input-wrap">
      <Lock size={16} className="sp-input-icon" />
      <input
        className="sp-input"
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      <button className="sp-eye-btn" type="button" onClick={() => setShow(p => !p)} tabIndex={-1}>
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
};

const Settings = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);

  // const [settings, setSettings] = useState({
  //   pushNotifications:  true,
  //   emailNotifications: false,
  //   darkMode:           false,
  //   availableForWork:   true,
  //   showPhoneNumber:    true,
  //   language:           'English',
  // });

  const [push_notifications, setPush_notifications] = useState(false);
  const [email_notifications, setEmail_notifications] = useState(false);
  const [availablity, setAvailablity] = useState(false);

  const [saved, setSaved] = useState(false);

  const [showChangePw, setShowChangePw] = useState(false);
  const [pwForm, setPwForm] = useState({ current: '', newPw: '', confirm: '' });
  const [pwError, setPwError] = useState('');
  const [pwSuccess, setPwSuccess] = useState(false);
  const [pwLoading, setPwLoading] = useState(false);

  // const toggle = (key) => setSettings(prev => ({ ...prev, [key]: !prev[key] }));

  const handleBack = () => navigate(-1);

  const view = () => {
    axios.get(
      `${baseUrl}/worker/setting`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`
        }
      }
    )
      .then((res) => {

        const data = res.data.setting;

        setPush_notifications(data.push_notifications);
        setEmail_notifications(data.email_notifications);
        setAvailablity(data.availablity);

      })
      .catch((err) => {
        console.log(err);
      });
  };


  const updateSetting =  (
  pushValue = push_notifications,
  emailValue = email_notifications,
  availableValue = availablity
) => {

    const formData = new FormData();

    formData.append('push_notifications', pushValue ? 1 : 0);
formData.append('email_notifications', emailValue ? 1 : 0);
formData.append('availablity', availableValue ? 1 : 0);

    axios.post(
      `${baseUrl}/worker/updatesetting`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`
        }
      }
    )
      .then((res) => {

        setSaved(true);
      })
      .catch((error) => {

        console.log("Full Error:", error);
        console.log("Response:", error.response);
        console.log("Data:", error.response?.data);

        alert("Error");
      });
  };

  const handleChangePassword = () => {
    setShowChangePw(p => !p);
    setPwError(''); setPwSuccess(false);
    setPwForm({ current: '', newPw: '', confirm: '' });
  };

  const handlePwSubmit = async () => {
  setPwError('');

  if (!pwForm.current || !pwForm.newPw || !pwForm.confirm) {
    setPwError('Please fill in all fields.');
    return;
  }

  

  if (pwForm.newPw !== pwForm.confirm) {
    setPwError('New passwords do not match.');
    return;
  }

  setPwLoading(true);

  try {
    const res = await axios.post(
      `${baseUrl}/worker/updatepassword`,
      {
        current_password: pwForm.current,
        new_password: pwForm.newPw,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`,
        },
      }
    );

    if (res.data.success) {
      setPwSuccess(true);
      setPwForm({ current: '', newPw: '', confirm: '' });

      setTimeout(() => {
        setShowChangePw(false);
        setPwSuccess(false);
      }, 2000);
    } else {
      setPwError(res.data.message || 'Password update failed');
    }
  } catch (err) {
    console.log(err.response?.data || err.message);
    setPwError(err.response?.data?.message || 'Server error');
  } finally {
    setPwLoading(false);
  }
};

  /* ── Delete Account — SweetAlert2 ── */
  const handleDeleteAccount = () => {
    Swal.fire({
      title: 'Delete Account?',
      html: `
      <p style="color:#484745;margin:0;line-height:1.6;">
        This will <strong>permanently remove</strong> your account,
        all your jobs, earnings, and data.<br/>
        <span style="color:#dc2626;">This action cannot be undone.</span>
      </p>
    `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      reverseButtons: true,
    }).then((result) => {

      if (result.isConfirmed) {

        axios.delete(`${baseUrl}/worker/deleteAccount`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        })

          .then((res) => {

            if (res.data.success) {

              localStorage.removeItem("authToken");

              Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: 'Your account has been deleted.',
                timer: 1500,
                showConfirmButton: false
              });

              navigate('/');
            }

          })

          .catch((err) => {
            console.log(err.response?.data || err.message);


          });
      }
    });
  };

  /* ── Logout — navigate to landing ── */
  const handleLogout = async () => {

    const result = await Swal.fire({
      title: 'Log Out?',
      text: 'Are you sure you want to logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, Logout',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    });

    if (!result.isConfirmed) return;

    try {

      const res = await axios.post(
        `${baseUrl}/worker/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`
          }
        }
      );

      if (res.data.success) {

        localStorage.removeItem("authToken");

        await Swal.fire({
          icon: 'success',
          title: 'Logged Out',
          text: 'You have been logged out successfully',
          timer: 1500,
          showConfirmButton: false
        });

        navigate('/');
      }

    } catch (err) {

      console.log("LOGOUT ERROR:", err.response?.data || err.message);

      // Swal.fire({
      //   icon: 'error',
      //   title: 'Logout Failed',
      //   text: 'Something went wrong'
      // });

    }
  };

  /* ── Section & Row helpers ── */
  const Section = ({ title, children }) => (
    <div className="settings-section">
      <p className="settings-section-title">{title}</p>
      <div className="settings-group">{children}</div>
    </div>
  );

  const ToggleRow = ({ icon, iconColor, iconBg, title, subtitle, checked, onToggle }) => (
    <div className="settings-row">
      <div className="settings-row-icon" style={{ background: iconBg, color: iconColor }}>{icon}</div>
      <div className="settings-row-text">
        <span className="settings-row-title">{title}</span>
        {subtitle && <span className="settings-row-subtitle">{subtitle}</span>}
      </div>
      <Toggle checked={checked} onChange={onToggle} />
    </div>
  );

  const LinkRow = ({ icon, iconColor, iconBg, title, subtitle, onClick, danger, active }) => (
    <button
      className={`settings-row settings-row--btn ${danger ? 'settings-row--danger' : ''} ${active ? 'settings-row--active' : ''}`}
      onClick={onClick}
    >
      <div className="settings-row-icon" style={{ background: iconBg, color: iconColor }}>{icon}</div>
      <div className="settings-row-text">
        <span className="settings-row-title">{title}</span>
        {subtitle && <span className="settings-row-subtitle">{subtitle}</span>}
      </div>
      <ChevronRight size={18} className={`settings-row-chevron ${active ? 'settings-row-chevron--open' : ''}`} />
    </button>
  );
  useEffect(() => {
    view();
  }, []);
  return (
    <>
      <WorkerNavbar />
      <div className="settings-page">

        <div className="settings-header">
          <button className="settings-back-btn" onClick={handleBack}><ArrowLeft size={24} /></button>
          <h2 className="settings-title">Settings</h2>
        </div>

        <div className="settings-content">

         <Section title="NOTIFICATIONS">

  <ToggleRow
    icon={<Bell size={20} />}
    iconColor="#0491e1"
    iconBg="#e8f4fd"
    title="Push Notifications"
    subtitle="Receive push notifications"
    checked={push_notifications}
    onToggle={(value) => {
      setPush_notifications(value);
      updateSetting(value, email_notifications, availablity);
    }}
  />

  <ToggleRow
    icon={<Mail size={20} />}
    iconColor="#8b5cf6"
    iconBg="#f3f0ff"
    title="Email Notifications"
    subtitle="Receive email updates"
    checked={email_notifications}
    onToggle={(value) => {
      setEmail_notifications(value);
      updateSetting(push_notifications, value, availablity);
    }}
  />

</Section>

          <Section title="PREFERENCES">

  <ToggleRow
    icon={<Briefcase size={20} />}
    iconColor="#10b981"
    iconBg="#e6f9f2"
    title="Available for Work"
    subtitle="Show as available to customers"
    checked={availablity}
    onToggle={(value) => {
      setAvailablity(value);
      updateSetting(push_notifications, email_notifications, value);
    }}
  />

</Section>

          <Section title="PRIVACY">
            <LinkRow icon={<Lock size={20} />} iconColor="#0491e1" iconBg="#e8f4fd"
              title="Change Password" subtitle="Update your password"
              onClick={handleChangePassword} active={showChangePw} />

            {showChangePw && (
              <div className="sp-panel">
                <div className="sp-panel-header">
                  <span className="sp-panel-title">Change Password</span>
                  <button className="sp-panel-close" onClick={() => setShowChangePw(false)}><X size={16} /></button>
                </div>

                {pwSuccess ? (
                  <div className="sp-success">
                    <CheckCircle size={36} />
                    <p>Password changed successfully!</p>
                  </div>
                ) : (
                  <>
                    <div className="sp-fields">
                      <div className="sp-field">
                        <label className="sp-label">Current Password</label>
                        <PasswordInput value={pwForm.current} placeholder="Enter current password"
                          onChange={e => setPwForm(p => ({ ...p, current: e.target.value }))} />
                      </div>
                      <div className="sp-field">
                        <label className="sp-label">New Password</label>
                        <PasswordInput value={pwForm.newPw} placeholder="Enter new password (min 6 chars)"
                          onChange={e => setPwForm(p => ({ ...p, newPw: e.target.value }))} />
                      </div>
                      <div className="sp-field">
                        <label className="sp-label">Confirm New Password</label>
                        <PasswordInput value={pwForm.confirm} placeholder="Re-enter new password"
                          onChange={e => setPwForm(p => ({ ...p, confirm: e.target.value }))} />
                      </div>
                    </div>
                    {pwError && <p className="sp-error">{pwError}</p>}
                    <button className={`sp-submit ${pwLoading ? 'sp-submit--loading' : ''}`}
                      onClick={handlePwSubmit} disabled={pwLoading}>
                      {pwLoading ? <><span className="sp-spinner" /> Updating...</> : 'Update Password'}
                    </button>
                  </>
                )}
              </div>
            )}
          </Section>

          <Section title="ACCOUNT">
            <LinkRow icon={<Trash2 size={20} />} iconColor="#dc2626" iconBg="#fef2f2"
              title="Delete Account" subtitle="Permanently remove your account"
              onClick={handleDeleteAccount} danger />
          </Section>

          <button className="settings-logout-btn" onClick={handleLogout}>
            <LogOut size={18} /> Log Out
          </button>

        </div>
      </div>
    </>
  );
};

export default Settings;